<template>
  <div class="app-container">
    <PurchaseViewForm is-copy />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/components/PurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseApplyIndexCopy',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {},
};
</script>
